<div class="order-details-page">

    <!-- Header -->
    <div class="page-header">
        <button class="back-btn" (click)="goBack()">
            <i *ngIf="!isRTL" class="bi bi-arrow-left"></i>
            <i *ngIf="isRTL" class="bi bi-arrow-right"></i>
        </button>
        <h1 class="page-title">{{ 'ORDERS.ORDER_DETAILS' | translate }}</h1>
    </div>

    <!-- Loading -->
    <div class="loading-content" *ngIf="isLoading">
        <div class="skeleton-box"></div>
        <div class="skeleton-box"></div>
        <div class="skeleton-box"></div>
    </div>

    <!-- Main content -->
    <div class="order-content" *ngIf="!isLoading && order">

        <!-- Order header -->
        <div class="section order-header-section">
            <div class="header-top">
                <div>
                    <p class="order-number">{{ 'ORDERS.ORDER_NO' | translate }} {{ order.orderNumber }}</p>
                    <p class="order-date">{{ formatDate(order.createdAt) }}</p>
                </div>
                <span class="status-badge" [ngClass]="'status-' + order.status.toLowerCase()">
                    {{ 'ORDERS.STATUS_' + order.status | translate }}
                </span>
            </div>
        </div>

        <!-- Delivery status stepper -->
        <div class="section">
            <h3 class="section-title">{{ 'ORDERS.DELIVERY_STATUS' | translate }}</h3>
            <div class="status-bar">

                <!-- Dots + Lines -->
                <div class="status-timeline">
                    <ng-container *ngFor="let step of statusSteps; let i = index; let isLast = last">
                        <div class="timeline-step" [class.completed]="isStatusCompleted(step.key)"
                            [class.active]="order.status === step.key">
                            <div class="step-dot"></div>
                        </div>
                        <div *ngIf="!isLast" class="step-line" [class.filled]="isLineActive(i)"></div>
                    </ng-container>
                </div>

                <!-- Labels -->
                <div class="status-labels">
                    <span *ngFor="let step of statusSteps" class="status-label"
                        [class.label-active]="isStatusCompleted(step.key) || order.status === step.key">
                        {{ 'ORDERS.STATUS_' + step.key | translate }}
                    </span>
                </div>

            </div>
        </div>

        <!-- Items -->
        <div class="section">
            <h3 class="section-title">{{ 'ORDERS.ITEMS' | translate }}</h3>
            <div class="items-list">
                <div class="item-card" *ngFor="let item of order.items">
                    <div class="item-image" *ngIf="item.imageUrl">
                        <img [src]="item.imageUrl" [alt]="item.productName" />
                    </div>
                    <div class="item-image empty" *ngIf="!item.imageUrl">
                        <i class="bi bi-image"></i>
                    </div>
                    <div class="item-details">
                        <p class="item-name">{{ item.productName }}</p>
                        <p class="item-price">
                            <span class="price-current">{{ item.unitPrice | currency:'EGP':'symbol':'1.0-0' }}</span>
                        </p>
                        <p class="item-color" *ngIf="item.colorName">{{ item.colorName }}</p>
                        <p class="item-size" *ngIf="item.size">{{ item.size }}</p>
                    </div>
                    <div class="item-qty">×{{ item.quantity }}</div>
                </div>
            </div>
        </div>

        <!-- Order summary -->
        <div class="section">
            <h3 class="section-title">{{ 'ORDER_CONF.ORDER_SUMMARY' | translate }}</h3>
            <div class="summary-table">
                <div class="summary-row">
                    <span class="summary-label">{{ 'ORDER_CONF.SUBTOTAL' | translate }}</span>
                    <span class="summary-value">{{ order.subtotal | currency:'EGP':'symbol':'1.0-0' }}</span>
                </div>
                <div class="summary-row" *ngIf="(order.subtotal - order.total) > 0">
                    <span class="summary-label">{{ 'ORDER_CONF.DISCOUNT' | translate }}</span>
                    <span class="summary-value discount">
                        -{{ (order.subtotal - order.total) | currency:'EGP':'symbol':'1.0-0' }}
                    </span>
                </div>
                <div class="summary-row total">
                    <span class="summary-label">{{ 'ORDER_CONF.TOTAL' | translate }}</span>
                    <span class="summary-value">{{ order.total | currency:'EGP':'symbol':'1.0-0' }}</span>
                </div>
            </div>
        </div>

        <!-- Customer info -->
        <div class="section" *ngIf="order.customerName">
            <h3 class="section-title">{{ 'ORDERS.CUSTOMER_INFO' | translate }}</h3>
            <div class="info-list">
                <div class="info-row">
                    <span class="info-label">{{ 'ORDERS.NAME' | translate }}</span>
                    <span class="info-value">{{ order.customerName }}</span>
                </div>
                <div class="info-row">
                    <span class="info-label">{{ 'ORDERS.PHONE' | translate }}</span>
                    <span class="info-value">{{ order.customerPhone }}</span>
                </div>
                <div class="info-row">
                    <span class="info-label">{{ 'ORDERS.EMAIL' | translate }}</span>
                    <span class="info-value">{{ order.customerEmail }}</span>
                </div>
            </div>
        </div>

        <!-- Delivery address -->
        <div class="section" *ngIf="order.streetAddress">
            <h3 class="section-title">{{ 'CHECKOUT_DELIVERY_ADDRESS' | translate }}</h3>
            <div class="info-list">
                <div class="info-row">
                    <span class="info-label">{{ 'FIELD_STREET' | translate }}</span>
                    <span class="info-value">{{ order.streetAddress }}</span>
                </div>
                <div class="info-row">
                    <span class="info-label">{{ 'FIELD_CITY' | translate }}</span>
                    <span class="info-value">{{ order.city }}</span>
                </div>
                <div class="info-row" *ngIf="order.region">
                    <span class="info-label">{{ 'FIELD_REGION' | translate }}</span>
                    <span class="info-value">{{ order.region }}</span>
                </div>
            </div>
        </div>

        <!-- Payment method -->
        <div class="section" *ngIf="order.paymentMethod">
            <h3 class="section-title">{{ 'CHECKOUT_PAYMENT_METHOD' | translate }}</h3>
            <p class="payment-method-text">
                {{ order.paymentMethod === 'CASH_ON_DELIVERY' ? ('PAYMENT_CASH' | translate) : ('PAYMENT_CARD' |
                translate) }}
            </p>
        </div>

        <!--  Action buttons - cancel only shown when order is cancellable -->
        <div class="action-section">
            <button class="btn btn-support" (click)="contactSupport()">
                <i class="bi bi-headset"></i>
                {{ 'ORDERS.SUPPORT' | translate }}
            </button>

            <!--  Hidden completely for SHIPPED / ON_WAY / DELIVERED / CANCELLED -->
            <button *ngIf="canCancelOrder" class="btn btn-cancel" (click)="openCancelSheet()">
                {{ 'ORDERS.CANCEL_ORDER' | translate }}
            </button>
        </div>

    </div>
</div>

<!--  Sheet overlay -->
<div class="sheet-overlay" *ngIf="showCancelSheet" (click)="closeCancelSheet()"></div>

<!--  Cancellation Bottom Sheet -->
<div class="cancel-sheet" [class.open]="showCancelSheet">

    <!-- Sheet handle -->
    <div class="sheet-handle"></div>

    <!-- Title -->
    <h3 class="sheet-title">{{ 'ORDERS.CANCEL_REASON_TITLE' | translate }}</h3>

    <!-- Reason options -->
    <div class="reasons-list">
        <div *ngFor="let r of cancelReasons" class="reason-option" [class.selected]="selectedReason === r.key"
            (click)="selectReason(r.key)">
            <span class="reason-label">{{ r.labelKey | translate }}</span>
            <span class="reason-radio" [class.checked]="selectedReason === r.key">
                <i class="bi bi-check-circle-fill" *ngIf="selectedReason === r.key"></i>
            </span>
        </div>
    </div>

    <!-- Note section - shown after ANY reason is selected -->
    <div class="note-wrapper" *ngIf="selectedReason">
        <label class="note-label">
            {{ 'ORDERS.CANCEL_NOTE_LABEL' | translate }}
            <!-- Required only for OTHER -->
            <span *ngIf="selectedReason !== 'OTHER_PROBLEM'" class="note-optional">
                ({{ 'ORDERS.OPTIONAL' | translate }})
            </span>
            <span *ngIf="selectedReason === 'OTHER_PROBLEM'" class="note-required">*</span>
        </label>
        <textarea class="custom-reason-input" [(ngModel)]="customReason" [placeholder]="(selectedReason === 'OTHER_PROBLEM'
        ? 'ORDERS.CANCEL_REASON_PLACEHOLDER'
        : 'ORDERS.CANCEL_NOTE_PLACEHOLDER') | translate" rows="3">
    </textarea>
    </div>

    <!-- Submit button -->
    <button class="sheet-submit-btn" [disabled]="!canSubmitCancel || isCancelling" (click)="submitCancel()">
        <span *ngIf="!isCancelling">{{ 'ORDERS.CANCEL_CONFIRM' | translate }}</span>
        <span *ngIf="isCancelling">{{ 'ORDERS.CANCELLING' | translate }}</span>
    </button>

</div>